import ProfitCalculator from '@/components/ProfitCalculator';
import { PdpInfoDTO } from '@/types/models';
interface PDPProfitCalculatorProps {
  data: PdpInfoDTO;
}
const PDPProfitCalculator = ({
  data
}: PDPProfitCalculatorProps) => {
  return <ProfitCalculator data={data} data-sentry-element="ProfitCalculator" data-sentry-component="PDPProfitCalculator" data-sentry-source-file="PDPProfitCalculator.tsx" />;
};
export default PDPProfitCalculator;